var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control border-0",attrs:{"type":"text","name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }